import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

const TOKEN_KEY = "atlas_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

export function apiErrorMessage(err, fallback = "Terjadi kesalahan. Coba lagi.") {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export async function openStoredFile(path, kind = "lampiran") {
  const resp = await api.get(`/files/${kind}/${path}`, { responseType: "blob" });
  const url = URL.createObjectURL(resp.data);
  window.open(url, "_blank", "noopener");
}

export async function downloadFile(path, filename, params) {
  const resp = await api.get(path, { responseType: "blob", params });
  const url = URL.createObjectURL(resp.data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}

export function formatTanggalID(yyyyMmDd) {
  if (!yyyyMmDd) return "—";
  try {
    const [y, m, d] = yyyyMmDd.split("-").map(Number);
    return new Intl.DateTimeFormat("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(new Date(y, m - 1, d));
  } catch {
    return yyyyMmDd;
  }
}

export function formatWaktuID(isoUtc) {
  if (!isoUtc) return "—";
  try {
    return new Intl.DateTimeFormat("id-ID", {
      dateStyle: "medium",
      timeStyle: "short",
    }).format(new Date(isoUtc));
  } catch {
    return isoUtc;
  }
}

export function formatRupiah(nilai) {
  if (nilai == null || isNaN(nilai)) return "Rp 0";
  return "Rp " + Number(nilai).toLocaleString("id-ID");
}

// Periode payroll 'YYYY-MM' = bulan gaji (mengikuti bulan tanggal akhir cutoff).
// cutoff 21 + periode 2026-07 → 21 Jun 2026 s/d 20 Jul 2026.
export function windowPeriodePayroll(periode, cutoffDay) {
  const [y, m] = String(periode || "").split("-").map(Number);
  if (!y || !m) return null;
  const cd = Math.max(1, Math.min(28, Number(cutoffDay) || 1));
  const iso = (dt) => dt.toISOString().slice(0, 10);
  if (cd === 1) {
    return { start: iso(new Date(Date.UTC(y, m - 1, 1))), end: iso(new Date(Date.UTC(y, m, 0))) };
  }
  return {
    start: iso(new Date(Date.UTC(y, m - 2, cd))),
    end: iso(new Date(Date.UTC(y, m - 1, cd - 1))),
  };
}

const BULAN_ID = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember",
];

export function labelPeriodePayroll(periode) {
  const [y, m] = String(periode || "").split("-").map(Number);
  if (!y || !m) return "—";
  return `Payroll ${BULAN_ID[m - 1]} ${y}`;
}
